<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ser"><img alt="9781618371621_0041_001" src="Images/9781618371621_0041_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e14922541"><i>Tomato and Ricotta Salata Bruschetta <br/> and Tuscan White-Bean Bruschetta</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c30_r1.vue?701d240f